import React from 'react'
import BackButton from '../components/BackButton'
import Sidebar from '../components/Sidebar'
import Card_1 from '../components/Card_1'
import { useLocation } from "react-router-dom";
import MobileNav from '../components/MobileNav';

export default function VideoPlayer() {

    const location = useLocation();
    const { video } = location.state || {};  // Get the video passed as state
    const { playlist } = location.state || {};  // Get the playlist passed as state

    console.log(video, playlist)
    return (
        <section className='body_section'>
            <BackButton />

            <Sidebar />

            <h2 className='my-4 bold' style={{color:'var(--main-yellow)'}} >{playlist?.name}</h2>

            <div className='row' >
                <div className='col-lg-8'  >

                    <div className='video_player_div' >
                        <video className='video_player w-100' controls autoPlay
                            src={video?.sourceFile} type="video/mp4"
                        ></video>
                    </div>
                    <h4 className='bold mt-2' >{video?.title}</h4>
                    <p>{video.description}</p>
                </div>


                <div className='col-lg-4'  >
                    <h3>{playlist? "Other videos" : ''}</h3>
                    <div className='d-flex flex-column gap-2' >
                        {playlist?.content?.map((video, index) => (
                            <Card_1 video={video} playlist={playlist} list={true} key={index} />
                        ))}
                    </div>

                </div>

            </div>
            <MobileNav />

        </section>
    )
}
